import { ReactElement, SVGProps } from 'react';
import BaseIcon from "./BaseIcon";

export default function EncryptedIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props} viewBox="0 0 20 20">
      <path
        d="M9.25 13.403h1.5a.41.41 0 0 0 .323-.157.38.38 0 0 0 .094-.343l-.396-2.188q.416-.208.656-.604.24-.395.24-.875 0-.687-.49-1.177A1.6 1.6 0 0 0 10 7.569q-.687 0-1.177.49t-.49 1.177q0 .48.24.875.24.396.656.604l-.396 2.188a.38.38 0 0 0 .094.343q.135.157.323.157m.75 5.75a1.7 1.7 0 0 1-.52-.084Q6.665 18.132 5 15.601q-1.667-2.532-1.667-5.448V6.215q0-.521.302-.937a1.7 1.7 0 0 1 .782-.604l5-1.875q.291-.105.583-.105.291 0 .583.105l5 1.875q.48.187.782.604t.302.937v3.938q0 2.916-1.667 5.448-1.666 2.53-4.48 3.468a1.6 1.6 0 0 1-.52.084"
        fill="currentColor"
      />
    </BaseIcon>
  )
}
